import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { companyInfo } from '../data/mock';
import ChatWidget from '../components/common/ChatWidget';

const ImprintPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-slate-900 mb-8">Impressum</h1>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-slate-100 space-y-8">
              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Angaben gemäß § 5 TMG</h2>
                <p className="text-slate-600">
                  {companyInfo.legal.company}<br />
                  {companyInfo.address.street}<br />
                  {companyInfo.address.zip} {companyInfo.address.city}<br />
                  {companyInfo.address.country}
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Vertreten durch</h2>
                <p className="text-slate-600">
                  Geschäftsführer: {companyInfo.legal.ceo}
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Kontakt</h2>
                <p className="text-slate-600">
                  Telefon: {companyInfo.contact.phone}<br />
                  E-Mail: {companyInfo.contact.email}
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Steuernummer</h2>
                <p className="text-slate-600">
                  208/200/51166
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Umsatzsteuer-ID</h2>
                <p className="text-slate-600">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                  DE18493472
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Berufsrechtliche Regelungen</h2>
                <p className="text-slate-600">
                  Finanzanlagenvermittler gemäß § 34f GewO<br />
                  Zuständige Aufsichtsbehörde: IHK München und Oberbayern
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Streitschlichtung</h2>
                <p className="text-slate-600">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                  <a href="https://ec.europa.eu/consumers/odr" className="text-blue-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="text-slate-600 mt-4">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Haftung für Inhalte</h2>
                <p className="text-slate-600">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                  allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
                  verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
                  zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Haftung für Links</h2>
                <p className="text-slate-600">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
                  Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
                  verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-4">Urheberrecht</h2>
                <p className="text-slate-600">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
                  deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                  außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen 
                  Autors bzw. Erstellers.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <ChatWidget />
    </div>
  );
};

export default ImprintPage;
